import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Box, Checkbox, FlatTextInput, Hint, Text } from '@common-fe/common-fe';

import { AUTO_SFTP_LOCATION, EMPTY_FIELD_VALUE } from '@/common/constants';

import FileLocationTitle from './FileLocationTitle';

interface Props {
  checked?: boolean;
  onChangeCheck: (value: boolean) => void;
  value?: string;

  isAutoFileLocation?: boolean;
  onSetAutoFileLocation: (value: boolean) => void;
  onChange: (value: string) => void;
  isError?: boolean;
  isViewMode?: boolean;
  disabled?: boolean;
}
const FileLocationField: React.FC<Props> = ({
  checked,
  onChangeCheck,
  value,
  onChange,
  isViewMode,
  disabled,
  isError,
  isAutoFileLocation,
  onSetAutoFileLocation,
}) => {
  const [currentChecked, setCurrentChecked] = useState(checked || false);
  const [currentValue, setCurrentValue] = useState(value || '');
  useEffect(() => {
    if (currentChecked !== checked) {
      onChangeCheck(currentChecked);
    }
  }, [checked, currentChecked, onChangeCheck]);

  useEffect(() => {
    if (currentValue !== value && !isAutoFileLocation) {
      onChange(currentValue);
    }
  }, [currentValue, isAutoFileLocation, onChange, value]);
  const errorMessage = useMemo(() => {
    if (isAutoFileLocation) {
      return '';
    }
    if (!isError) {
      return '';
    }
    if (currentValue.trim().length > 0) {
      return '';
    }
    return 'This field is required';
  }, [currentValue, isAutoFileLocation, isError]);
  const handleSetAutoLocation = useCallback(
    (value: boolean) => {
      if (value) {
        onChange(AUTO_SFTP_LOCATION);
        setCurrentValue('');
      }
      onSetAutoFileLocation(value);
    },
    [onChange, onSetAutoFileLocation]
  );

  if (isViewMode && !checked) {
    return EMPTY_FIELD_VALUE;
  }

  return (
    <Box direction="column">
      <Checkbox
        testId="isSendFiles"
        disabled={disabled}
        checked={currentChecked}
        onChange={setCurrentChecked}
      />
      {currentChecked && (
        <Box width="320px" direction="column">
          <FileLocationTitle value={isViewMode ? value || '' : ''} />
          {!isViewMode && (
            <>
              <Box direction="row" margin={{ top: '8px' }}>
                <FlatTextInput
                  testId="file-location_input"
                  disabled={disabled || isAutoFileLocation}
                  // isError={true}
                  errorText={errorMessage}
                  value={isAutoFileLocation ? '' : currentValue}
                  placeholder="File location"
                  onChange={setCurrentValue}
                />
                <Hint>
                  <Text size="small">Enter the exact name you gave the folder in your S3 bucket.</Text>
                </Hint>
              </Box>

              <Box margin={{ top: 'spacing8' }}>
                <Checkbox disabled={disabled} checked={isAutoFileLocation} onChange={handleSetAutoLocation}>
                  <Text>Automatically process all files from "/incoming" folder</Text>
                </Checkbox>
              </Box>
            </>
          )}
        </Box>
      )}
    </Box>
  );
};

export default FileLocationField;
